import { FC } from 'react'
import { ButtonType } from '../../../../../_metronic/helpers'
import { Button, InfoAlert, useModal } from '../../../../components'
import { formatDateToPtBr } from '../../../../../_metronic/helpers'
import { formatFaixaHorario } from '../core/escalaHelpers'
import { BlocoAgenda } from './EscalaCalendario'

type Props = {
  bloco: BlocoAgenda
}

/**
 * Conteúdo mostrado quando a empresa aciona um bloco de **indisponibilidade
 * global** no calendário.
 *
 * O bloco vem com `vinculos` vazio: é uma ausência que o profissional registrou
 * sem empresa nenhuma, logo vale para todas em que ele é médico ativo. A empresa
 * precisa vê-la (é o que impede agendar em cima de uma férias), mas não pode
 * editá-la nem excluí-la — `GET /escalas/empresa/{empresa}/{id}` e
 * `GET /escalas/empresa/agenda/{empresa}/{id}` devolvem **403** nesses casos.
 *
 * Por isso a tela explica em vez de deixar o clique estourar num erro de
 * permissão que o QA reportaria como bug.
 */
export const IndisponibilidadeGlobalModal: FC<Props> = ({ bloco }) => {
  const { closeModal } = useModal()

  return (
    <div>
      <InfoAlert variant='info' title='Registrada pelo profissional para todas as instituições'>
        Esta ausência não pertence a esta empresa: o profissional a registrou sem escolher empresa,
        então ela vale para todas em que ele tem vínculo de médico ativo. Ela aparece aqui para que
        a agenda não ofereça horários nesse período, mas só o próprio profissional pode alterá-la ou
        removê-la, em <strong>Escalas &gt; Minha escala</strong>.
      </InfoAlert>

      <dl className='row mb-0'>
        <dt className='col-sm-4'>Profissional</dt>
        <dd className='col-sm-8'>{bloco.titulo || 'Não informado'}</dd>

        <dt className='col-sm-4'>Data</dt>
        <dd className='col-sm-8'>{formatDateToPtBr(bloco.data)}</dd>

        <dt className='col-sm-4'>Período</dt>
        <dd className='col-sm-8'>
          {formatFaixaHorario(bloco.horarioInicio, bloco.horarioTermino)}
        </dd>
      </dl>

      <div className='d-flex justify-content-end pt-5'>
        <Button className='btn-primary' type={ButtonType.Button} onClick={closeModal}>
          Entendi
        </Button>
      </div>
    </div>
  )
}
